import React, { useCallback, useEffect, useState } from 'react';
import { Table, Button, Input, Tag, Tabs, Modal, Popconfirm, Row, Col } from 'antd';
import { useAuthContext } from 'contexts/Auth';
import emailjs from '@emailjs/browser'
import axios from 'axios';
const { TabPane } = Tabs;

const All = () => {
    const { getApiConfig, user } = useAuthContext()
    const [users, setUsers] = useState([]);
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [admins, setAdmins] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [invitingId, setInvitingId] = useState(null);
    // ✅ Memoized fetchUsers
    const fetchUsers = useCallback(async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${window.api}/users/all`, getApiConfig());
            setUsers(response.data.users); // backend should send { users: [...] }
        } catch (error) {
            console.error("Error fetching users:", error);
            window.toastify("Failed to fetch users", "error");
        } finally {
            setLoading(false);
        }
    }, [getApiConfig]);

    useEffect(() => {
        fetchUsers(); // only re-runs if fetchUsers changes
    }, [fetchUsers]);



    const fetchAdmins = useCallback(async () => {
        try {
            const response = await axios.get(`${window.api}/admins/all`, getApiConfig());
            setAdmins(response.data.admins);
        } catch (error) {
            console.error(error);
            window.toastify("Error fetching admin list", "error");
        }
    }, [getApiConfig]);

    useEffect(() => {
        fetchAdmins();
    }, [fetchAdmins]);

    const createAdmin = async () => {

        if (!email) {
            window.toastify("Email is required", "error");
            return;
        }

        if (!window.isEmail(email)) {
            window.toastify("Please enter a valid email address", "error");
            return;
        }

        setIsLoading(true);
        try {
            const response = await axios.post(`${window.api}/admins/add`, { email }, getApiConfig());

            const { data, status } = response;

            if (status === 201 || status === 200) {
                window.toastify(data.message, "success");
                setEmail("")
                setIsModalVisible(false)
                fetchAdmins()
            }
        } catch (error) {
            // console.error("Create Admin Error:", error);
            window.toastify(error.response?.data?.message || "Something went wrong", "error");
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${window.api}/admins/${id}`, getApiConfig());
            window.toastify("Admin deleted.", "success");
            fetchAdmins();
            fetchUsers();
        } catch (error) {
            console.error(error);
            window.toastify("Failed to delete admin.", "error");
        }
    };

    // const handleInvite = async (id) => {
    //     try {
    //         const res = await axios.patch(`${window.api}/admins/${id}/invite`, {}, getApiConfig());
    //         window.toastify(res.data.message, "success");
    //         fetchAdmins(); // Refresh data
    //     } catch (error) {
    //         console.error("Invite error:", error);
    //         window.toastify(error.response?.data?.message || "Failed to send invitation", "error");
    //     }
    // };

    // const inviteViaEmail = (formData) => {

    //     console.log("formData", formData);
    //     // return
    //     const { email, addedBy } = formData

    //     const url = `${window.origin}/auth/create-account/?email=${email}&id=${addedBy}`;
    //     let data = { ...formData, url }

    //     const msg = {
    //         to: `zaiddev60gb@gmail.com`,
    //         subject: `Invitation message from ${window.appName}`,
    //         // text: `Salaam ${fullName}`,
    //         data
    //     };
    //     axios.post(`${window.api}/admins/send-email-invitation`, msg, getApiConfig())
    //         .then(res => {
    //             const { status } = res
    //             if (status === 200) {
    //                 window.toastify("Email successfully sent", "success")
    //             }
    //         })
    //         .catch(err => {
    //             console.error(err)
    //             window.toastify("Something went wrong, We couldn't send email. Please contact support team.", "error")
    //         })
    // }



    const inviteViaEmail = async (formData) => {
        const { email, addedBy, fullName, id } = formData;
        const url = `${window.origin}/auth/create-account/?email=${email}&id=${id}&uid=${addedBy}`;

        const templateParams = {
            to_email: email,               // 📩 Recipient's email
            to_name: fullName,                              // 👤 Recipient's name
            invited_by: user?.fullName || user?.email || "Admin",  // 👈 dynamically from logged-in user
            invitation_link: url,  // 🔗 Registration link
            time: new Date().toLocaleString()                 // 🕒 Current timestamp (optional, used in email)
        };
        setInvitingId(formData._id);
        try {
            const response = await emailjs.send(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                templateParams,
                process.env.REACT_APP_EMAILJS_PUBLIC_KEY
            );

            console.log('SUCCESS!', response.status, response.text);
            window.toastify("Email successfully sent", "success");

        } catch (error) {
            console.error('FAILED...', error);
            window.toastify("Something went wrong, couldn't send email.", "error");

        } finally {
            setInvitingId(null);
        }
    };


    // const inviteViaEmail = async (formData) => {

    //     const { email, addedBy, id } = formData;
    //     const url = `${window.origin}/auth/create-account/?email=${email}&id=${id}&uid=${addedBy}`;

    //     const data = {
    //         email,
    //         invitedBy: user?.fullName || user?.email || "Admin",
    //         invitationLink: url
    //     };

    //     setInvitingId(formData._id);
    //     try {
    //         const res = await axios.post(`${window.api}/admins/send-email-invitation`, data, getApiConfig());
    //         if (res.status === 200) {
    //             window.toastify("Email successfully sent", "success");
    //         }
    //     } catch (err) {
    //         console.error(err);
    //         window.toastify("Something went wrong, couldn't send email.", "error");
    //     } finally {
    //         setInvitingId(null);
    //     }
    // };




    const userColumns = [
        { title: 'Name', dataIndex: 'fullName', key: 'fullName' },
        { title: 'Email', dataIndex: 'email', key: 'email' },

        {
            title: 'Roles',
            dataIndex: 'roles',
            key: 'roles',
            render: (roles) => (
                <>
                    {roles.map((role, idx) => (
                        <Tag color={role === 'superAdmin' ? 'red' : 'blue'} key={idx}>
                            {role}
                        </Tag>
                    ))}
                </>
            )
        },

        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => (
                <Tag color={status === 'active' ? 'green' : 'volcano'}>
                    {status.toUpperCase()}
                </Tag>
            )
        },

        { title: 'Created At', dataIndex: 'createdAt', key: 'createdAt' },
    ];

    const adminColumns = [
        { title: "Email", dataIndex: "email", key: "email" },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => (
                <Tag color={status === "active" ? "green" : "orange"}>
                    {status.toUpperCase()}
                </Tag>
            )
        },
        { title: "Added By", dataIndex: "addedBy", key: "addedBy" },
        {
            title: "Created At",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (date) => new Date(date).toLocaleString(),
        },
        {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
                <div className='d-flex'>
                    <Button
                        type="primary"
                        onClick={() => inviteViaEmail(record)}
                        loading={invitingId === record._id}
                        style={{ marginRight: 8 }}
                    >
                        Invite
                    </Button>

                    <Popconfirm
                        title="Are you sure you want to delete this admin?"
                        description=""
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => handleDelete(record._id)}
                    >
                        <Button danger>Delete</Button>
                    </Popconfirm>
                </div>
            ),
        }
    ];

    return (
        <div className="p-4">
            <h2 className="text-xl font-semibold mb-4">Admin Management</h2>

            <Row>
                <Col span={24}>
                    <div className="card">
                        <Tabs defaultActiveKey="users">
                            <TabPane tab="All Users" key="1">
                                <Table
                                    columns={userColumns}
                                    dataSource={users}
                                    rowKey={(record) => record._id || record.email}
                                    loading={loading}
                                    scroll={{ x: true }}
                                    size='small'
                                />
                            </TabPane>

                            <TabPane tab="Admins" key="2">
                                <div className="d-flex flex justify-content-end mb-2">
                                    <Button type="primary" onClick={() => setIsModalVisible(true)}>
                                        Add Admin
                                    </Button>
                                </div>
                                <Table
                                    columns={adminColumns}
                                    dataSource={admins}
                                    rowKey={(record) => record._id || record.email}
                                    scroll={{ x: true }}
                                    size='small'
                                />
                            </TabPane>
                        </Tabs>

                        <Modal
                            title="Add Admin"
                            open={isModalVisible}
                            onOk={createAdmin}
                            onCancel={() => setIsModalVisible(false)}
                            confirmLoading={isLoading}
                            okText="Add"
                        >
                            <Input
                                placeholder="Enter admin email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Modal>

                    </div>
                </Col>
            </Row>


        </div>
    );
};

export default All;
